<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <div class="d-flex mx-7 pt-5 justify-space-between">
          <h5 class="text-h5">Data Testimoni</h5>
          <v-btn v-if="!isEdit" density="compact" @click="isEdit = true"
            >Edit <v-icon class="ml-1">mdi-pen</v-icon></v-btn
          >
        </div>
        <v-card-text>
          <v-form ref="form" v-model="isValid" class="pl-4 pr-4">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="currentData.judul"
                        :disabled="!isEdit"
                        label="Judul"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.judulRules"
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.konten"
                        :disabled="!isEdit"
                        label="Konten"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.kontenRules"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="currentData.judul_en"
                        :disabled="!isEdit"
                        label="Judul Inggris"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.judulRules"
                      ></v-text-field>
                      <v-textarea
                        v-model="currentData.konten_en"
                        :disabled="!isEdit"
                        label="Konten Inggris"
                        clearable
                        dense
                        outlined
                        required
                        :rules="currentData.kontenRules"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-combobox
                    v-model="currentData.selectedHide"
                    :disabled="!isEdit"
                    label="Publish"
                    dense
                    outlined
                    :items="currentData.items_hide"
                    item-text="name"
                    item-value="code"
                  ></v-combobox>
                  <v-file-input
                    v-model="filefoto"
                    :disabled="!isEdit"
                    label="Upload Foto"
                    accept="image/*"
                    prepend-icon="mdi-image"
                    clearable
                    dense
                    outlined
                    @change="loadImage"
                  >
                  </v-file-input>
                  <v-row v-if="currentData.FotoUrl" class="my-5">
                    <v-col cols="12" sm="6" md="4">
                      <v-responsive :aspect-ratio="16 / 9">
                        <v-img :src="currentData.FotoUrl" contain></v-img>
                      </v-responsive>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div v-if="isEdit">
                <CardGallery />
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <div style="height: 60px"></div>
        <v-card-actions v-if="isEdit">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="isEdit = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "../../utils/utils.js";
import CommonService from "../../services/CommonService";
import TestimoniService from "../../services/web_content/TestimoniService";
import CardGallery from "../../components/CardGallery.vue";

const form = ref(null);
const isValid = ref(false);

// Composables
const router = useRouter();

// State
const breadcrumbs = [
  {
    text: "Testimoni",
    disabled: false,
    href: "/webcontent/testimoni",
  },
  {
    text: "Edit Testimoni",
    disabled: true,
    href: "breadcrumbs_dashboard",
  },
];

const isEdit = ref(false);
const filefoto = ref(null);

const currentData = reactive({
  id: "",
  judul: "",
  konten: null,
  judul_en: "",
  konten_en: null,
  selectedHide: null,
  foto_url: "",
  FotoUrl: "",
  items_hide: [
    { code: 1, name: "Publish" },
    { code: 2, name: "Hide" },
  ],
  judulRules: [(v) => !!v || "Judul harus diisi"],
  kontenRules: [(v) => !!v || "Konten harus diisi"],
});

// This state is preserved from the original setup function for the quill editor
const state = reactive({
  content: "",
  _content: "",
  editorOption: {
    placeholder: "Tulis konten di sini..",
    modules: {},
  },
  disabled: false,
});

// Methods
const loadImage = (file) => {
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      currentData.FotoUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  } else {
    currentData.FotoUrl = "";
    currentData.foto_url = null;
  }
};

const getData = () => {
  const data = sessionStorage.getItem("item_testimoni");
  if (!data) {
    console.error("Testimonial data not found in sessionStorage.");
    // Optionally redirect or show an error
    router.push("/webcontent/testimoni");
    return;
  }

  const testimoni = JSON.parse(data);
  currentData.id = testimoni.id;
  currentData.judul = testimoni.title;
  currentData.konten = testimoni.testimoni;

  currentData.judul_en = testimoni.title_en;
  currentData.konten_en = testimoni.testimoni_en;
  currentData.FotoUrl = testimoni.foto_url;

  // Preserve state for quill editor from original logic
  state._content = testimoni.testimoni;
  state.content = testimoni.testimoni;

  // Find and set the selectedHide object
  currentData.selectedHide =
    currentData.items_hide.find(
      (entry) => entry.code == testimoni.data_status,
    ) || null;
};

const doSave = async () => {
  try {
    await form.value.validate();

    if (!isValid.value) {
      window.scrollTo(0, 0);
      return;
    }

    await TestimoniService.update(
      currentData,
      currentData.konten,
      filefoto.value,
    );
    CommonService.showSuccessToast("Update testimoni berhasil");
    router.push("/webcontent/testimoni");
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Update testimoni gagal. Coba lagi");
  }
};

// Lifecycle Hooks
onMounted(() => {
  getData();
});
</script>
